import React, { useState, useEffect, useRef  } from "react";
import { Shield, BarChart3, Users, Scale, User, Search } from "lucide-react";

import Banner from "../components/Banner";
import bannerimg from "../assets/img/privacybg.jpg";

const sections = [
  { id: "intro", title: "1. Introduction" },
  { id: "info", title: "2. Information We Collect" },
  { id: "usage", title: "3. How We Use Your Information" },
  { id: "sharing", title: "4. Sharing of Information" },
  { id: "security", title: "5. Data Security" },
  { id: "rights", title: "6. Your Rights" },
  { id: "cookies", title: "7. Cookies & Tracking" },
  { id: "thirdparty", title: "8. Third-Party Services" },
  { id: "policy", title: "9. Updates to This Policy" },
  { id: "contactus", title: "10. Contact Us" },
];

function PrivacyPolicy() {
    const [active, setActive] = useState("intro");
    const sidebarRef = useRef(null);
    const containerRef = useRef(null);

    const cards = [
    { icon: <Shield size={24} />, title: "Data Protection First", desc: "We prioritize the security of sensitive data with advanced encryption and strict access controls." },
    { icon: <BarChart3 size={24} />, title: "Insight Without Compromise", desc: "Extract meaningful insights from data while ensuring top-level privacy and security." },
    { icon: <Users size={24} />, title: "Community Trust Driven", desc: "We earn trust through transparency, accountability, and responsible data practices." },
    { icon: <Scale size={24} />, title: "Ethical Research Practices", desc: "Research is conducted with integrity, adhering to ethical and regulatory standards." },
    ];

    useEffect(() => {
        const handleScroll = () => {
            const sidebar = sidebarRef.current;
            const container = containerRef.current;
            const contactSection = document.getElementById("contactus");

            if (!sidebar || !container || !contactSection) return;

            const scrollY = window.scrollY;
            const topOffset = 100;

            const containerTop = container.offsetTop;
            const sidebarHeight = sidebar.offsetHeight;

            // 👇 MAIN FIX
            const contactTop = contactSection.offsetTop;

            // ======================
            // ✅ STICKY LOGIC
            // ======================
            if (scrollY > containerTop - topOffset) {

            // 👉 jab tak contact section nahi aata
            if (scrollY + sidebarHeight + topOffset < contactTop) {
                sidebar.style.position = "fixed";
                sidebar.style.top = topOffset + "px";
            } else {
                // 👉 yaha unstick hoga (FIX)
                sidebar.style.position = "relative";
                sidebar.style.top =
                (contactTop - containerTop - sidebarHeight) + "px";
            }

            } else {
            sidebar.style.position = "relative";
            sidebar.style.top = "0px";
            }

            // ======================
            // ✅ SCROLL SPY
            // ======================
            const sections = document.querySelectorAll("section[id]");
            let current = "";

            sections.forEach((section) => {
            const sectionTop = section.offsetTop - 160;
            const sectionHeight = section.offsetHeight;

            if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
                current = section.getAttribute("id");
            }
            });

            if (current) {
            setActive(current);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
        }, []);



  return (
    <>
      <div className="position-relative"> 

        <Banner
          containerWidth="w-50"
          title="Your Data. Your Control. Our Responsibility."
          subtitle="We protect your insights while helping you shape industries."
          bgImage={bannerimg}
          headingcenter="text-center"
        />

        {/* TOP SECTION */}
        {/* <section className="bg-white ptb60px px-3">
          <div className="container">

            <h2 className="headinglg mx-auto px-6 text-center w-75" data-aos="fade-up">
              "Privacy is the foundation of meaningful research and honest insights."
            </h2>

            <div className="mt-5 d-flex flex-wrap roundbdrbox gap-4" data-aos="fade-up">
              {cards.map((item, index) => (
                
                  <div className="roundbdrcol">

                    <div className="bg-danger text-white rounded p-2 mb-4 d-inline-flex">
                      {item.icon}
                    </div>

                    <h5 className="fw-bold mb-3">{item.title}</h5>
                    <p className="text-secondary small">{item.desc}</p>

                  </div>
                
              ))}
            </div>

          </div>
        </section> */}

        {/* MAIN CONTENT */} 
        <section className="bg-white px-3 ptb60px pb100px prtext" ref={containerRef}>
          <div className="container">
            <div className="row g-5 stickyrow">

              {/* SIDEBAR */}
              <div className="col-lg-3 leftsidebar">
                <div className="sticky-sidebar" ref={sidebarRef}>
                  <h5 className="fw-bold">Table of Contents</h5>

                  <ul id="sidebar-nav" className="nav flex-column mt-3">
                    {sections.map((item) => (
                      <li key={item.id}>
                        <a
                          href={`#${item.id}`}
                          className={`d-block px-3 py-3 rounded text-decoration-none ${
                            active === item.id
                              ? "bgbluebox2 fw-semibold"
                              : "text-secondary"
                          }`}
                          style={{ fontSize: "15px" }}
                        >
                          {item.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* CONTENT */}
              <div className="col-lg-9 rightpart">

                {/* SECTION 1 */}
                <section id="intro" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                    <span className="">1.</span> Introduction
                    </h2>
                    <p className="">
                    At Industry & People (I&P), your privacy is not just a policy — it's a responsibility.</p>

                    <p className="">
                    We are committed to protecting your personal data while enabling a secure environment where professionals can share insights, conduct research, and collaborate meaningfully. By using our platform, 
                    you agree to the practices outlined in this Privacy Policy.</p>
                    
                </section>

                {/* SECTION 2 */}
                <section id="info" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                    <span className="">2.</span> Information We Collect
                    </h2>

                    <p className="">
                    We collect information to improve your experience and ensure meaningful interactions within the community.
                    </p>

                    <div className="d-flex gap-4 mt-5 infolistbox">
                        {/* Card */}
                        <div className="bggraycol d-flex w-50">
                            <div className="iconbox">
                            <User size={22} />
                            </div>
                            <div>
                            <h4 className="fw-bold mb-2">Personal Information</h4>
                            <ul className="ml-4">
                                <li>Full Name</li>
                                <li>Email Address</li>
                                <li>Professional Details</li>
                            </ul>
                            </div>
                        </div>

                        <div className="bggraycol d-flex w-50">
                            <div className="iconbox">
                            <BarChart3 size={18} />
                            </div>
                            <div>
                            <h4 className="fw-bold mb-2">Usage Data</h4>
                            <ul className="ml-4">
                                <li>Platform activity</li>
                                <li>Interaction with content</li>
                                <li>Login and session data</li>
                            </ul>
                            </div>
                        </div>
                    </div>

                    <div className="bggraycol d-flex mt-4">
                        <div className="iconbox">
                            <Search size={18} />
                        </div>
                        <div>
                            <h4 className="fw-bold mb-2">Research Data</h4>
                            <ul className="list-disc ml-4">
                            <li>Survey responses</li>
                            <li>Community insights</li>
                            </ul>
                        </div>
                    </div>

                    
                </section>

                
                <section id="usage" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                        <span className="">3.</span> How We Use Your Information
                    </h2>

                    <p className="">
                        Your data helps us create a better, smarter platform.
                    </p>

                    <p className="fw-bold">
                        We use your information to:
                    </p>

                    <ul className="">
                        <li>Provide and improve our services</li>
                        <li>Facilitate research and surveys</li>
                        <li>Maintain platform security</li>
                        <li>Enable community interactions</li>
                        <li>Personalize your experience</li>
                    </ul>
                </section>
                

                <section id="sharing" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                        <span className="">4.</span> Sharing of Information
                    </h2>

                    <p className="">
                        We respect your data and do not sell your personal information.
                    </p>

                    <p className="fw-bold">
                        We may share data only in the following cases:
                    </p>

                    <ul className="mb-4">
                        <li>With your consent</li>
                        <li>To comply with legal obligations</li> 
                        <li>For research purposes (anonymized data only)</li>
                    </ul>
                    
                </section>

                <section id="security" className="mb50px" data-aos="fade-up">
                        <h2 className="">
                            <span className="">5.</span> Data Security
                        </h2>

                        <p className="fw-bold">
                            We implement strong security measures to protect your data:
                        </p>

                        <ul className="mb-4">
                            <li>Encrypted data storage</li>
                            <li>Restricted access controls</li> 
                            <li>Secure authentication systems</li>
                        </ul>                           

                        

                        {/* Highlight Box */}
                        <div className="mt-4">
                            <p className=" fst-italic fs-15 mb-0">
                            However, no system is 100% secure, and we continuously improve our safeguards.</p>
                            
                        </div>
                </section>

                <section id="rights" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                        <span className="">6.</span> Your Rights
                    </h2>

                    <p className="fw-bold">
                        You have full control over your data.
                    </p>

                    <ul className="mb-4">
                        <li>Access your data</li>
                        <li>Request deletion of your data</li>                                    
                        <li>Request corrections</li>
                        <li>Opt-out of communications</li>
                    </ul>
                    

                    {/* Highlight Box */}
                    <div className="bgbluebox divround">
                        <p className="fw-bold mb-0">
                        To exercise your rights, contact us at:
                        </p>
                        <a
                        href="mailto:support@inpcommunity.com"
                        className="textbluecolor fs-15"
                        >
                        support@inpcommunity.com
                        </a>
                    </div>
                </section>

                <section id="cookies" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                        <span className="">7.</span> Cookies & Tracking
                    </h2>

                    <p className="fw-bold">
                        We use cookies to:
                    </p>
                    
                    <ul className="mb-4">
                        <li>Improve user experience</li>
                        <li>Enhance performance</li>
                        <li>Analyze platform usage</li>
                    </ul>                                   
                    

                    <p className="">
                        You can manage cookie preferences through your browser settings.
                    </p>
                </section>

                <section id="thirdparty" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                        <span className="">8.</span> Third-Party Services
                    </h2>

                    <p className="">
                        We may use trusted third-party tools for analytics and platform functionality.
                    </p>

                    <p className="fw-bold">
                        These services comply with standard data protection practices.
                    </p>
                </section>

                <section id="policy" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                        <span className="">9.</span> Updates to This Policy
                    </h2>

                    <p className="">
                        We may update this Privacy Policy periodically.
                    </p>

                    <p className="fw-bold">
                        Users will be notified of significant changes.
                    </p>
                </section>

                <section id="contactus" className="mb50px" data-aos="fade-up">
                    <h2 className="">
                        <span className="">10.</span> Contact Us
                    </h2>

                    <p className="">
                        If you have questions about this Privacy Policy:
                    </p>

                    <p className="textbluecolor fs-15">
                        support@inpcommunity.com
                    </p>
                </section> 

              </div>

            </div>
          </div>
        </section>

      </div>
    </>
  );
}

export default PrivacyPolicy;